import React from 'react';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { number, object, string } from 'prop-types';

import CartDesktop from './CartDesktop';
import CartMobile from './CartMobile';
import CardOrderSummary from './CardOrderSummary';

import css from './CartInfoPanel.module.css';
import { useSelector } from 'react-redux';

const CartInfoPanel = props => {
    const {
        rootClassName,
        className,
        titleClassName,
        isHideRemoveButton,
        layout,
    } = props;
    const cartState = useSelector(state => state.cart);

    const listItems = props.listItems || cartState.cartItems;
    const totalPrice = props.totalPrice || cartState.totalPrice;
    const discount = props.discount || cartState.discount;
    const originalPrice = props.originalPrice || cartState.originalPrice;
    console.log("listItemslistItems", listItems)
    const classes = classNames(layout === 'checkout' ? css.checkoutRoot : (rootClassName || css.root), className);
    const titleClasses = classNames(titleClassName || css.cartInfoTitle);
    const numberOfItems = listItems?.length;

    return (
        <div className={classes}>
            {
                layout === 'checkout' ? <></> : (
                    <div className={titleClasses}>
                        <FormattedMessage id="CartInfoPanel.title" values={{ numberOfItems }} />
                    </div>
                )
            }
            {listItems.length > 0 && (
                <div className={css.cartInfoOrderDetails}>
                    <div className={css.orderDetailsTittle}>
                        <FormattedMessage id="CartInfoPanel.orderDetails" />
                    </div>
                    <CartDesktop listItems={listItems} isHideRemoveButton={isHideRemoveButton} layout={layout} />
                    <CartMobile listItems={listItems} isHideRemoveButton={isHideRemoveButton} layout={layout} />


                    <CardOrderSummary
                        discount={discount}
                        originalPrice={originalPrice}
                        totalPrice={totalPrice}
                        numberOfItems={numberOfItems}
                        layout={layout}
                    />
                </div>
            )}
        </div>
    );
}

CartInfoPanel.defaultProps = { rootClassName: null, className: null };

CartInfoPanel.propTypes = {
    rootClassName: string,
    className: string,
    titleClassName: string,
    totalPrice: object.isRequired,
    discount: object.isRequired,
    originalPrice: object.isRequired,
    numberOfItems: number,
    listItems: object.isRequired,
};

export default CartInfoPanel;
